import React from 'react';

export type ScheduleTimelineScale = 'today' | 'weeks' | 'months';

interface ScheduleTimelineScaleSwitcherProps {
  value: ScheduleTimelineScale;
  onChange: (value: ScheduleTimelineScale) => void;
  'aria-label'?: string;
}

const ScheduleTimelineScaleSwitcher: React.FC<ScheduleTimelineScaleSwitcherProps> = ({
  value,
  onChange,
  'aria-label': ariaLabel = 'Schedule timeline scale',
}) => {
  return (
    <div className="schedule-scale-switcher schedule-scale-switcher--legend" role="group" aria-label={ariaLabel}>
      <button
        type="button"
        className={`schedule-scale-btn ${value === 'today' ? 'active' : ''}`}
        onClick={() => onChange('today')}
      >
        Today
      </button>
      <button
        type="button"
        className={`schedule-scale-btn ${value === 'weeks' ? 'active' : ''}`}
        onClick={() => onChange('weeks')}
      >
        Weeks
      </button>
      <button
        type="button"
        className={`schedule-scale-btn ${value === 'months' ? 'active' : ''}`}
        onClick={() => onChange('months')}
      >
        Months
      </button>
    </div>
  );
};

export default ScheduleTimelineScaleSwitcher;
